@if (content.pendingConsent) {
  <div>
    <nsc-card [error]="true">
      <nsc-card-title-error icon="warning" title="Order Pending" [headingLevel]="3">
        <div class="mat-title">
          Order Is Pending A Signed Consent
        </div>
        <div >
          Please go to www.xxxxxx.org and complete the consent process so that your order can be forwarded to your school for fulfillment.
        </div>
      </nsc-card-title-error>
      <!-- <nsc-card-content>
    </nsc-card-content> -->
  </nsc-card>
  <nsc-spacer size="md"></nsc-spacer>
</div>
}

<nsc-card-consent ></nsc-card-consent>

<nsc-card>
  <nsc-card-title>Requestor Information</nsc-card-title>
  <nsc-card-content>
    <div class="row nsc-order-confirmation__requestor">
      <div class="col-12 col-lg-6 px-0">
         <ul class="nsc-order-confirmation__requestor__details-list" aria-label="Requestor Information">
          <li class="row">
            <div class="col-4">
              <em>Order Number:</em>
            </div>
            <div class="col-6" id="order_id">
              {{ content.orderId }}
            </div>
          </li>
          <li class="row">
            <div class="col-4">
              <em>School:</em>
            </div>
            <div class="col-6">
              {{ content.schoolProfile.schlName }}
            </div>
          </li>
          @if (content.requestor.toScCampusName) {
            <li class="row">
              <div class="col-4">
                <em>Campus:</em>
              </div>
              <div class="col-8">
                {{ content.requestor.toScCampusName }}
              </div>
            </li>
          }
          @if (content.state) {
            <li class="row">
              <div class="col-4">
                <em>State:</em>
              </div>
              <div class="col-6">
                {{ content.state }}
              </div>
            </li>
          }
          <li class="row">
            <div class="col-4">
              <em>Name:</em>
            </div>
            <div class="col-6">
              {{ content.requestor.firstName }} {{ content.requestor.middleName }} {{ content.requestor.lastName }}
            </div>
          </li>
          @if (content.requestor.schlFirstName) {
            <li class="row">
              <div class="col-4">
                <em>Previous Name:</em>
              </div>
              <div class="col-6">
                {{ content.requestor.schlFirstName }} {{ content.requestor.schlMiddleName }} {{ content.requestor.schlLastName }}
              </div>
            </li>
          }
          @if (content.allowStudentName) {
            <li class="row">
              <div class="col-4">
                <em>{{content.studentNameLabel}}:</em>
              </div>
              <div class="col-6">
                {{ content.requestor.livedFirstName }} {{ content.requestor.livedMiddleName }} {{ content.requestor.livedLastName }}
              </div>
            </li>
          }
          @if (content.orderDate) {
            <li class="row">
              <div class="col-4">
                <em>Order Date:</em>
              </div>
              <div class="col-6">
                {{ content.orderDate }} ET
              </div>
            </li>
          }
        </ul>
      </div>
      <div class="col-12 col-lg-6">
        @if (content.payment && content.payment.payeezyToken) {
          <div >
            <div class="row">
              <div class="col-4">
                <em>Credit Card:</em>
              </div>
              <div class="col-6">
                {{ content.payment.payeezyToken.slice(-4) }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <em>Billing Address:</em>
              </div>
              <div class="col-7">
                @if (content.payment && !content.payment.emailPrimary) {
                  <div>
                    {{ content.payment.billStreet1 }}<br>
                    {{ content.payment.billStreet2 }}@if (content.payment.billStreet2) {
                    <br>
                    }
                    {{ content.payment.billCity }}, {{ content.payment.billState }} {{ content.payment.billZip }}
                    @if (content.payment && content.payment.billCountry !== 'UNITED STATES') {
                      <div>{{ content.payment.billCountry }}</div>
                    }
                  </div>
                }
                @if (content.payment && content.payment.emailPrimary) {
                  <div>
                    {{ content.payment.emailPrimary }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </nsc-card-content>
</nsc-card>

<nsc-spacer size="lg"></nsc-spacer>

<nsc-card>
  <nsc-card-title>Recipient Order Details</nsc-card-title>
  <nsc-card-content>
    <ul class="nsc-recipient-list">
      @for (recipient of content.recipients; track recipient; let i = $index) {
        <li>
          <nsc-recipient-details
            [recipient]="recipient">
          </nsc-recipient-details>
          @if (i < content.recipients.length - 1) {
            <nsc-spacer size="xs"></nsc-spacer>
            <hr class="nsc-hr">
            <nsc-spacer size="xs"></nsc-spacer>
          }
        </li>
      }
    </ul>

    <nsc-spacer size="md"></nsc-spacer>

    <div class="row justify-content-end">
      <div class="col-auto">
        @if (content.recipients.length > 0) {
          <div class=" mat-elevation-z0 nsc-order-total">
            Total Fee for Order: <strong>{{ content.totalFees | currency }}</strong>
          </div>
        }
      </div>
    </div>

    <nsc-spacer size="lg"></nsc-spacer>

    <div class="text-center">
      @if (content.totalFees) {
        <span>Your credit card will not be charged until transcript(s) are sent. The charge for this transaction will appear on your credit card statement as 'Student Clearinghouse'.</span>
        } An order confirmation will be sent to <strong>{{ content.requestor.email }}</strong>. Thank you for your order!
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md"></nsc-spacer>

  @if (content.referMethodSaml) {
    <div class="nsc-form-actions">
      <button
        mat-raised-button
        id="logout"
        class="nsc-form-actions__button "
        color="primary"
        type="button"
      (click)="logout()">logout</button>
    </div>
  }
  <nsc-spacer size="md"></nsc-spacer>
  <div class="text-center">
    <p class="subtitle-1">
      For security purposes, close your browser.
    </p>
  </div>
